import React from "react";
import { SearchField } from "../../components";
import Header from "./header";
import Body from "./body";

const FlashCardsPresentation = ({
  add,
  adding,
  cancel,
  close,
  currentDeck,
  decks,
  findValue,
  isbn,
  selectCurrentDeck,
  showOnboarding,
  newCardFront,
  setFindValue
}) => {
  const headerTitle = currentDeck
    ? currentDeck.title
    : i18n.t("reader.panels.flashcards");
  return (
    <div id="flashcards">
      <Header
        add={add}
        close={close}
        currentDeck={currentDeck}
        playDisabled={
          currentDeck &&
          (currentDeck.cards
            ? currentDeck.cards.length === 0
            : currentDeck.card_count === 0)
        }
        selectCurrentDeck={selectCurrentDeck}
        title={headerTitle}
      />
      {currentDeck && (
        <div className="search-header">
          <SearchField
            placeholder={i18n.t("reader.flashcards.search-deck", {
              deckName: headerTitle
            })}
            onChange={setFindValue}
            value={findValue}
            incremental
          />
        </div>
      )}
      <Body
        adding={adding}
        cancel={cancel}
        close={close}
        currentDeck={currentDeck}
        decks={decks}
        findValue={findValue}
        newCardFront={newCardFront}
        isbn={isbn}
        selectCurrentDeck={selectCurrentDeck}
        showOnboarding={showOnboarding}
      />
    </div>
  );
};

export default FlashCardsPresentation;
